<template>
  <div>
    <div class="formulario">

      <div class="formulario_titulo"> 
        <h2> Gestión de Visitantes </h2>
        <hr>
      </div>

      <div class="formulario_cuerpo">
                
        <table class="tabla" v-show="datos.length">
          <thead  >
            <tr class="tabla_cabecera">
              <th class="columnas_cabecera" >
                Índice
              </th>
               <th class="columnas_cabecera"  >
                Nombre
              </th>
               <th class="columnas_cabecera"  >
                Correo Electrónico  
              </th>
               <th class="columnas_cabecera"  >
                No. Visitas  <div class="botonOrdenar" @click="ordenar(1)"></div>
              </th>
               <th class="columnas_cabecera"  >
                Perfil  <div class="botonOrdenar" @click="ordenar(2)"></div>
              </th>
            </tr>
          </thead>
          
          <tbody  class="tabla_cuerpo">
            <tr v-for="(dato,index) in datos">
              <td>{{index +1}}</td>
              <td>{{dato.nombre_visitante}}</td>
              <td>{{dato.correo_visitante}}</td>
              <td>{{dato.visitas_visitante}}</td>
              <td>{{perfiles[dato.perfil_visitante-1]}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="formulario_pie"> 
         <router-link class="atras" 
              v-bind:to="'/gestion'">
              <img class="atras" src="../assets/img/atras.svg"/>
        </router-link>
      </div>
    </div>
  </div>
</div>
</template>
<script>

import cabecera from '../components/cabecera.vue'
import pie from '../components/pie.vue'

import axios from 'axios'
import store from '../store'

export default {
  name: 'formulario',
  components: {
    cabecera, 
    pie, 
  },
   data() {
    return {
      Visitante: '',
      VisitanteEditado: '',
      datos: [],
      marcadores: [],
      perfiles: ['Administrativo', 'Docente','Estudiante',  'Público'],
      columns: ['Índice', 'Nombre del Visitante',  'Correo Electrónico','No. Visitas' ,'Perfil' ],
    
      
    }
  },
  methods: {
    consultaApi(opc) {
      this.datos.length = 0;
      axios.get('http://cimogsys.espoch.edu.ec:3000/api/'+ opc).then((response) => {
      //axios.get('http://localhost:3000/api/'+ opc).then((response) => {
        this.datos = response.data.data;
        console.log(this.datos);
      });
    },
    update: function(){
      this.VisitanteEditado="nombreVisitante="+this.editInput.nombreVisitante+
                    "&correoVisitante="+this.editInput.correoVisitante+
                    "&perfilVisitante="+this.editInput.perfilVisitante;
      axios.put('http://cimogsys.espoch.edu.ec:3000/api/updateVisitante/'+this.editInput.idVisitante,this.VisitanteEditado)
      //axios.put('http://localhost:3000/api/updateVisitante/'+this.editInput.idVisitante,this.VisitanteEditado)
        .then(response => {
          console.log(response)
          this.showModal=false;
          this.showModal2=true;
          if(response=200){
            this.mensaje="Editado correctamente";
            this.consultaApi("visitantes");

          }
        })
        .catch(e => {
          this.showModal2=true;
          this.mensaje="Ocurrió un error. Ingrese datos correctos";
        })
    }
  },
  mounted() {
    this.consultaApi("visitantes");
  }
}

</script>

<style  lang="scss"  scoped src="../sass/formulario.scss"></style>



// WEBPACK FOOTER //
// src/components/formularioVisitante.vue